/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect, useState } from 'react'
import mnsClient from '../apollo/mnsClient'
import { GET_MNS_NAME } from '../apollo/queries'
import { isAddress } from '../utils'

const useMnsName = (lp: any): { infoOne: any } => {
  const [infoOne, setInfoOne] = useState<any>()

  useEffect(() => {
    const fetchData = async () => {
      const addr = lp?.user?.id ? lp.user.id : lp
      if (isAddress(addr)) {
        const { data } = await mnsClient.query({
          query: GET_MNS_NAME(),
          variables: { id: addr },
          fetchPolicy: 'cache-first',
        })
        if (lp?.user?.id) {
          setInfoOne({
            ...lp,
            address: addr,
            mnsName: data.wrappedDomains[0]?.domain?.name?.toLocaleUpperCase(),
            isSuccess: true,
          })
        } else {
          setInfoOne({
            address: addr,
            mnsName: data.wrappedDomains[0]?.domain?.name?.toLocaleUpperCase(),
            isSuccess: true,
          })
        }
      }
    }
    fetchData()
  }, [lp])

  return { infoOne }
}

export default useMnsName
